import  React from 'react';
import {Component, Button, Div} from './styles/TaskBarComponent-style';
import {useNavigate} from 'react-router-dom';
import CheckUserIsAuthed from './CheckUserIsAuthed.js';



const TaskBarComponent = (props) => {

    const isOnLoginOrRegisterPage = props.isOnLoginOrRegisterPage;

    const navigate = useNavigate();
    const NavigateToHomePage = () => navigate('/');
    const NavigateToAboutPage= () => navigate('/About');
    const NavigateToRegisterPage = () => navigate('/Register');
    const NavigateToSearchPage = () => navigate('/Search');



    return (
        <Component className='taskbar'>
            <Div className='wrapper'>
                <Button onClick={NavigateToHomePage}>Home</Button>
                <Button onClick={NavigateToAboutPage}>About</Button>
                <Button onClick={NavigateToRegisterPage}>Register</Button>
                <Button onClick={NavigateToSearchPage}>Search</Button>
                { isOnLoginOrRegisterPage ? (
                        <div></div>
                    ) : (
                        <CheckUserIsAuthed />
                    )}
            </Div>
        </Component>
    );
};

export default TaskBarComponent;

